/**
 * Is Date Valid validation
 *
 * @param {*} value
 *
 * @return {String}
 */

import dayjs from 'dayjs';

export default function isDateValid (value) {
    if (!value) {
        return '';
    }

    return dayjs().isValid(value) ? '' : 'validation.error.date';
}
